import React from 'react';
import PageHeader from '../../../../components/PageHeader';
import { Box, Button, IconButton, Stack, TablePagination, Tooltip, Typography } from '@mui/material';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import { useTheme } from '@emotion/react';
import Datatable from '../../../../components/DataTable';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SendIcon from '@mui/icons-material/Send';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useState } from 'react';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import { useEffect } from 'react';
import moment from 'moment';
import SendReportToContact from './SendReportToContact';
import ReportDetails from './ReportDetails';
import { useTranslation } from 'react-i18next';

const screeningStatus = {
  pending: '#FFCBCA',
  submitted: '#006DFF1A',
  resubmit: '#FFB30057',
  approved: '#00A63226',
  completed: '#14285A1A',
  pendingColor: '#B11B1B',
  submittedColor: '#B6720C',
  resubmitColor: '#006DFF',
  approvedColor: '#00A632',
  completedColor: '#14285A',
};

export default function Report({ data }) {
  const {t} = useTranslation()
  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '10%',
      default: true,
      columnEditable: false,
      activeColumn: true,
    },
    {
      id: 1,
      header: 'Report ID',
      accessor: 'reportId',
      width: '25%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      capitalize: true,
    },
    {
      id: 2,
      header: 'Verifier',
      accessor: 'verifierName',
      width: '25%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      capitalize: true,
    },
    {
      id: 1,
      header: 'Date',
      accessor: 'createdOn',
      width: '20%',
      Cell: (value) => (
        <Stack>
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {moment(value?.createdOn).format('DD-MMM-YYYY') || '-'}
          </Typography>
        </Stack>
      ),
    },
    // {
    //   id: 4,
    //   header: 'Status',
    //   accessor: 'type',
    //   width: '20%',
    //   default: true,
    //   columnEditable: true,
    //   activeColumn: true,
    // },
    {
      id: 5,
      header: 'Status',
      accessor: 'screeningStatus',
      width: '20%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      jcc: true,
      Cell: (item) => (
        <div className="flex !justify-center">
          <Stack
            justifyContent={'center'}
            alignItems={'center'}
            className="fw-regular fs-12 ff-Roboto h-[28px] w-[100px] px-[10px] rounded-[16px] capitalize"
            sx={{ backgroundColor: screeningStatus[item?.type], color: screeningStatus[`${item?.type}Color`] }}
          >
            {item?.type === 'inprogress' ? 'In Progress' : t(item?.type)}
          </Stack>
        </div>
      ),
    },
  ];

  const theme = useTheme();
  const text = theme.palette.primary.text;

  const [reportList, setReportList] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openSendReportDialog, setOpenSendReportDialog] = useState(false);
  const [openViewReport, setOpenViewReport] = useState(false);

  

  const [payload, setPayload] = useState({
    page: 1,
    limit: 50,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    companyTypeFilter: [],
    field: '_id',
    sortOrder: 'desc',
  });

  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, filter: search }));
  };

  let source = CancelToken.source();

  const getReportList = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `fleet/shipReports/${data?._id}`,
      {
        pageNumber: payload.page,
        pageSize: payload.limit,
        filter: payload.filter ? payload.filter : null,
      },
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setReportList(data.response?.response);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    setList(
      reportList.map((res, index) => {
        return {
          ...res,
          Sno: index + 1,
          isSelected: false,
        };
      }),
    );
  }, [reportList]);

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    setSelectedReport(checkedStatus ? item : null);
  };

  useEffect(() => {
    if (list.length > 0) {
      if (selectedReport) {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: res._id === selectedReport._id,
          };
        });
        setList(items);
      } else {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: false,
          };
        });
        setList(items);
      }
    }
  }, [selectedReport]);

  const initApi = async () => {
    await getReportList();
  };

  useEffect(() => {
    if (data) {
      initApi();
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [data, payload.filter]);

  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  return (
    <Stack flex={1}>
      <Stack flex={1}>
        <PageHeader
          tableType={'2'}
          handleFilterButton={true}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
        >
          <Stack
            direction="row"
            flex={1}
            className="px-[16px]"
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Typography
              className="fs-14 ff-Roboto fw-medium"
              color={text}
            >
              {t('Reports')}
            </Typography>
            <Stack
              direction="row"
              alignItems={'center'}
            >
              <Tooltip
                disableInteractive
                title={t('View details')}
              >
                <IconButton onClick={() => setOpenViewReport(true)} disabled={!selectedReport}>
                  <MenuBookIcon style={{ width: '18px', height: '18px' }} />
                </IconButton>
              </Tooltip>
              <Tooltip
                disableInteractive
                title={t('Send report')}
              >
                <IconButton
                  onClick={() => setOpenSendReportDialog(true)}
                  disabled={selectedReport?.type !== 'completed'}
                  // disabled={selectedReport?.type !== 'completed'}
                >
                  <SendIcon style={{ width: '18px', height: '18px' }} />
                </IconButton>
              </Tooltip>
              {/* <Tooltip
                disableInteractive
                title={''}
              >
                <IconButton>
                  <FilterListIcon style={{ width: '18px', height: '18px' }} />
                </IconButton>
              </Tooltip> */}
            </Stack>
          </Stack>
          <Stack flexGrow={1} />
        </PageHeader>
        <Stack className="relative overflow-auto flex-auto  h-0">
          <Datatable
            tableHeadBgColor={'#e2eeff'}
            showCheckBox={true}
            columns={customerManagementColumn}
            data={list || []}
            isLoading={loading}
            // onClickRow={(item, index) => {
            //   selectRow(item, index);
            // }}
            onChangeCheckBox={handleOnChangeCheckBox}
            onChangeFilter={(filterValues) => {
              const sortValues = filterValues?.sort;
              let columnUpdate = customerManagementColumn;
              columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
              if (sortValues) {
                columnUpdate = columnUpdate.map((res) => {
                  return {
                    ...res,
                    sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                  };
                });
              }
              setCustomerManagementColumn(columnUpdate);
              if (sortValues) {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order, role: filterValues?.filter.selectValue }));
              } else {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, role: filterValues?.filter.selectValue }));
              }
            }}
            sortChange={(sortValues) => {
              const columnUpdate = customerManagementColumn.map((res) => {
                return {
                  ...res,
                  sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                };
              });
              setCustomerManagementColumn([...columnUpdate]);
              setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order }));
            }}
          />
        </Stack>
        <Stack
          sx={{ width: '100%' }}
          className="relative pl-[16px]   inputFormStyle"
        >
          <Box className="flex  justify-end items-center h-[56px] w-[100%] p-[5px]">
            {/* <TablePagination
              sx={{ borderBottom: 0 }}
              rowsPerPageOptions={[]}
              count={payload.totalLength ? payload.totalLength : 0}
              rowsPerPage={payload.limit ? payload.limit : 10}
              page={payload.paginationPage ? payload.paginationPage : 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            /> */}
          </Box>
        </Stack>
      </Stack>
      {openSendReportDialog && (
        <SendReportToContact
          modelOpen={openSendReportDialog}
          onModelHandleClose={() => setOpenSendReportDialog(false)}
          voyageId={selectedReport?.voyageId}
        />
      )}
      {openViewReport && (
        <ReportDetails
          modelOpen={openViewReport}
          onModelHandleClose={() => setOpenViewReport(false)}
          voyageId={selectedReport?.voyageId}
          reportDetails={selectedReport}
          data={data}
        />
      )}
    </Stack>
  );
}
